import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWarehouseAppContext } from '../hooks/useWarehouseAppContext';
import { OrderList } from '../components/OrderList';
import { Scanner } from '../components/Scanner';
import { BsBox, BsQrCodeScan } from 'react-icons/bs';
import { OutboundOrder } from '../../../api/warehouse/generated/src';

export const OrderListPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    orders,
    isScanning,
    scanType,
    handleScan,
    startOrderScanning,
    closeScanner,
  } = useWarehouseAppContext();

  const handleOrderSelect = (order: OutboundOrder | null) => {
    if (order) {
      navigate(`/warehouse/order/${order.id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-6 mb-4">
          <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
            <BsBox className="text-blue-600" />
            Warenausgang
          </h1>

          {/* <button
            onClick={startOrderScanning}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-blue-700 transition"
          >
            <BsQrCodeScan size={20} />
            Auftrag scannen
          </button> */}

           <Scanner
              // isActive={isScanning && scanType === 'order'}
              isActive={true}
              scanType="order"
              onScan={handleScan}
              onClose={closeScanner}
            />
        </div>

        <OrderList
          orders={orders}
          onOrderSelect={handleOrderSelect}
        />
      </div>
    </div>
  );
};
